<template>
    <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-6" v-if="customer_type === 'farmer'">
              <div class="label">
                {{ lodash.startCase($t('customers.farms.name')) }}
              </div>
              <div class="value">
                {{ office.name }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="label">
                {{ lodash.startCase($t('customers.regions.province')) }}
              </div>
              <div class="value">
                {{ provinceName }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="label">
                {{ lodash.startCase($t('customers.regions.regency')) }}
              </div>
              <div class="value">
                {{ regencyName }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="label">
                {{ lodash.startCase($t('customers.regions.district')) }}
              </div>
              <div class="value">
                {{ districtName }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="label">
                {{ lodash.startCase($t('customers.regions.village')) }}
              </div>
              <div class="value">
                {{ villageName }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="label">
                {{ lodash.startCase($t('customers.full_address')) }}
              </div>
              <div class="value">
                {{ office.address || '-' }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="label">
                {{ lodash.startCase($t('customers.coordinate')) }}
              </div>
              <div class="value">
                {{ office.coordinate || '-' }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
            <latlng-picker
                :center="(office.latitude && office.longitude)? {lat: Number(office.latitude), lng: Number(office.longitude)} : {lat: -6.200000, lng: 106.816666}"
                :zoom="office.region ? (office.region.id.length + 3) : 7"
                map-type-id="hybrid"
                class="mb-3 d-flex justify-content-end"
                v-model="office.coordinate"
                disabled
            >
            </latlng-picker>
        </div>
    </div>
</template>

<script>
    import LatlngPicker from "@/components/inputs/latlng-picker";
    export default {
        name: 'customer-office-show',
        components: {
            LatlngPicker,
        },
        props: {
            office: {
                type: Object,
                default: undefined
            },
            customer_type: {
                type: String,
                default: undefined
            }
        },
      computed: {
          regions() {
            if (!this.office.region_full_name) return [];
            return this.office.region_full_name.split(', ');
          },
          provinceName() {
            return this.regions[0] ?? '-'
          },
        regencyName() {
            return this.regions[1] ?? '-'
        },
        districtName() {
            return this.regions[2] ?? '-'
        },
        villageName() {
            return this.regions[3] ?? '-'
        }
      }
    }
</script>

<style scoped lang="scss">
    .custom-group {
    margin-bottom: 30px;
    }
    .custom-label,
    .custom-text {
    font-family: Lato;
    font-size: 14px;

    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
    }
    .custom-label,
    .label {
    font-size: 13px;
    font-weight: 700;
    color: #161b4d;
    text-transform: capitalize;
    margin-bottom: 4px;
    }
    .custom-text,
    .value {
    font-size: 14px;
    font-weight: 400;
    color: #171717;
    margin-bottom: 16px;
    }

    ::v-deep{
        .gmap-autocomplete.pac-target-input {
            display: none;
        }

        .vue-map-container {
            width: 320px !important;
            height: 150px !important;
        }
    }
    //.value:not(.no-colon)::before {
    //    content: ": ";
    //}
</style>